export default __webpack_public_path__ + "static/media/signout-small.3aa5ca9c.svg";